import type { ReactNode } from 'react';

interface SummaryBarProps {
  children: ReactNode;
}

export default function SummaryBar({ children }: SummaryBarProps) {
  return (
    <div className="rounded-3xl bg-card p-6 shadow-ambient space-y-4">
      {children}
    </div>
  );
}
